import React from 'react';
import {Link} from 'react-router-dom';
import {HashLink} from 'react-router-hash-link';

const BtnWrap = (props) => {
  if(props.hash){
    return (
      <HashLink to = {props.to} download = {props.download} target={`${props.download ? `_blank` : `_self`}`}>
        {props.children}
      </HashLink>
    )
  }else{

    if(props.to && !!props.to.includes("http")){
      return (
        <a href = {props.to} download = {props.download} target={`_blank`} >
          {props.children}
        </a>
      )
    }else if(props.to && !!props.to.includes("mailto:")){
      return (
        <a href = {props.to} target={`_blank`} >
          {props.children}
        </a>
      )
    }else{
      return (
        <Link to = {props.to ? props.to : "/" } onClick = {props.onClick} download = {props.download} target={`${props.download ? `_blank` : `_self`}`} >
          {props.children}
        </Link>
    
      );
    }
    
  }
  
}

export default BtnWrap;